import React from 'react';
import AlternativeTemplate from './templates/AlternativeTemplate';
import { buildAlternative } from './config/alternatives';

const cfg = buildAlternative('sevdesk');
export default function SevdeskAlternative() { return <AlternativeTemplate cfg={cfg} />; }
